import { render, staticRenderFns } from "./footerv.vue?vue&type=template&id=20245b62&scoped=true&"
import script from "./footerv.vue?vue&type=script&lang=js&"
export * from "./footerv.vue?vue&type=script&lang=js&"
import style0 from "./footerv.vue?vue&type=style&index=0&id=20245b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20245b62",
  null
  
)

export default component.exports